// analytics/rankingAnalytics.js
//
// Custom Rankings events go to GA4 via trackEvent like every event; the
// funnel events are also sent to the server log (/rankings/events), which
// counts guests too, keyed by the same anonymous visitor id My Top Movies
// uses — never by anything personal, and never the ranking title.
// Events sent with a onceKey reach the server once per page load; the server
// also de-duplicates page-view-style events per day.
import { ANALYTICS_EVENTS, trackEvent } from './index';
import { getVisitorId } from './topMoviesAnalytics';
import { apiRequest } from '../services/api';

const SERVER_EVENTS = new Set([
    ANALYTICS_EVENTS.RANKING_EDITOR_OPENED,
    ANALYTICS_EVENTS.RANKING_CREATION_STARTED,
    ANALYTICS_EVENTS.RANKING_CREATED,
    ANALYTICS_EVENTS.RANKING_SHARED,
    ANALYTICS_EVENTS.RANKING_VIEWED,
    ANALYTICS_EVENTS.RANKING_MAKE_YOUR_OWN_CLICKED,
    ANALYTICS_EVENTS.RANKING_MAKE_YOUR_OWN_COMPLETED,
    ANALYTICS_EVENTS.RANKING_SIGNUP_STARTED,
    ANALYTICS_EVENTS.RANKING_SIGNUP_COMPLETED,
]);

const sentOnce = new Set();

function sendToServer(eventType, listSlug, properties) {
    apiRequest('/rankings/events', {
        method: 'POST',
        body: { visitorId: getVisitorId(), events: [{ eventType, listSlug, properties }] },
        quiet: true,
        retry: { retries: 0 },
    }).catch(() => null);
}

/**
 * @param {string} eventName  one of ANALYTICS_EVENTS.RANKING_*
 * @param {object} [properties]  size, composition, logged_in, source, action, ... (never the title)
 * @param {{ listSlug?: string, onceKey?: string }} [options]
 */
export function trackRanking(eventName, properties = {}, { listSlug = null, onceKey = null } = {}) {
    if (onceKey) trackEvent(eventName, properties, { onceKey });
    else trackEvent(eventName, properties);
    if (!SERVER_EVENTS.has(eventName)) return;
    if (onceKey) {
        const key = `${eventName}:${onceKey}`;
        if (sentOnce.has(key)) return;
        sentOnce.add(key);
    }
    sendToServer(eventName, listSlug, properties);
}

export function __resetRankingAnalyticsForTest() {
    sentOnce.clear();
}
